import { WorkOrder } from '@quorum/models/xs-resource';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface WorkOrdersState extends EntityState<WorkOrder> {}

export const workOrdersAdapter: EntityAdapter<WorkOrder> = createEntityAdapter<WorkOrder>({
  selectId: (workOrder: WorkOrder) => workOrder.id
});

export const initialState: WorkOrdersState = workOrdersAdapter.getInitialState({});
export const workOrdersFeatureSelector = createFeatureSelector<any>('fixedOperations');
export const workOrdersSelector = createSelector(
  workOrdersFeatureSelector,
  (state: any) => state.workOrders
);
export const { selectIds, selectEntities, selectAll, selectTotal } = workOrdersAdapter.getSelectors(workOrdersSelector);
